import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'np-ai-button',
    templateUrl: './np-ai-button.component.html',
    styleUrl: './np-ai-button.component.css',
    standalone: false
})
export class NpAiButtonComponent {
    @Input() text: string;
    @Input() hint: string;
    @Input() disabled: boolean = false;

    @Output() clicked = new EventEmitter<void>();

    protected readonly icon =
        "data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='white'><path d='M12 2l1.9 5.6L19.5 9.5l-5.6 1.9L12 17l-1.9-5.6L4.5 9.5l5.6-1.9z'/><path d='M19 14l.9 2.6L22.5 17.5l-2.6.9L19 21l-.9-2.6L15.5 17.5l2.6-.9z'/></svg>";
}
